
import React from 'react';
import { Block, CancelOutlined, CheckCircleOutline, Error, SpeakerNotesOff, Create, WarningOutlined } from '@material-ui/icons';
import EsperandoFirma from '../Icons/EsperandoFirma';
import { CONSTANTS } from '../../../constants/constants';

const IconMap = {
  [CONSTANTS.STEP.STATUS.SIGNED]: <CheckCircleOutline style={{ fontSize: 24, color: '#0DC599' }} />,
  [CONSTANTS.STEP.STATUS.SEND_TO_SIGN]: <div style={{ height: 24 }}><EsperandoFirma /></div>,
  [CONSTANTS.STEP.STATUS.REJECTED]: <SpeakerNotesOff style={{ fontSize: 24, color: '#B00020' }} />,
  [CONSTANTS.STEP.STATUS.EXPIRED]: <SpeakerNotesOff style={{ fontSize: 24, color: '#B00020' }} />,
  [CONSTANTS.STEP.STATUS.CANCELLED]: <CancelOutlined style={{ color: '#B00020', fontSize: 24 }} />,
  [CONSTANTS.STEP.STATUS.ERROR]: <Error style={{ color: '#B00020', fontSize: 24 }} />,
  [CONSTANTS.STEP.STATUS.INIT]: <Block style={{ color: '#737373', fontSize: 24 }} />,
  'warning': <WarningOutlined style={{ color: '#EED202', fontSize: 24 }} />,
  'create': <Create style={{ color: '#FC7B1E', fontSize: 24 }} />,
  [CONSTANTS.STEP.STATUS.SIGNING]: <div style={{ height: 24 }}><EsperandoFirma /></div>
};

export default IconMap;
